/* ModaConcrete — minimum order per product, in the cart drawer and on the cart page.
   2026-10-13 (Eugene): pavers ship by freight and are too heavy to send a piece or two by parcel, so each paver
   (product type "Pavers") is 5 pieces at least (10 until 2026-10-29). Hyperion has no minimum (Eugene 2026-10-29: a
   few pieces ship by parcel). The product page calculator already starts at the minimum; this covers every other
   way into the cart (quick add, changing a quantity, a shared cart).
   It reads /cart.js and adds up each product's pieces across its colors; add-ons (lines nested under a product,
   and the sealer / bush-hammering products) don't count. While a product is short, checkout is turned off and a
   note says what to add. Checkout itself is not enforced here: that needs a cart validation Function (an app).
   window.mcMinByType = { 'Pavers': 5 } overrides the minimums.
   Add-ons on their own (Eugene 2026-10-13: not buyable alone): the sealer and bush-hammering are applied to the pavers
   or coping ordered with them, so a cart with an add-on and no pavers or coping can't check out either. */
(function () {
  'use strict';
  var MIN = window.mcMinByType || { 'Pavers': 5 };
  var NO_MIN = [8783731523737]; // Hyperion Modular Concrete Paver (Eugene 2026-10-29)
  var ADDON_PRODUCTS = [8790298787993, 8790298853529]; // Penetrating Sealer, Bush-Hammered Finish (per sq ft)
  // the product types each add-on is applied to: sealer on pavers or coping; bush-hammering on pavers only
  // (coping is bush-hammered as standard, R11, Eugene 2026-10-14)
  var HOSTS = { 8790298787993: ['Pavers', 'Pool Coping'], 8790298853529: ['Pavers'] };
  var CHECKOUT = '#CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]';
  var EXPRESS = '.additional-checkout-buttons, .cart__dynamic-checkout-buttons, shopify-accelerated-checkout-cart';
  var short = [], orphan = false, timer = null, busy = false, watched = [], tries = 0;

  function shortOf(cart) {
    var by = {};
    (cart && cart.items || []).forEach(function (it) {
      var min = MIN[it.product_type];
      if (!min || it.parent_relationship || ADDON_PRODUCTS.indexOf(it.product_id) !== -1 ||
        NO_MIN.indexOf(it.product_id) !== -1) return;
      var p = by[it.product_id] || (by[it.product_id] = { title: it.product_title, have: 0, min: min });
      p.have += it.quantity;
    });
    return Object.keys(by).map(function (k) { return by[k]; }).filter(function (p) { return p.have < p.min; });
  }

  function orphanOf(cart) {
    var items = cart && cart.items || [], isAddon = function (it) { return ADDON_PRODUCTS.indexOf(it.product_id) !== -1; };
    return items.some(function (a) {
      if (!isAddon(a)) return false;
      var hosts = HOSTS[a.product_id] || [];
      return !items.some(function (it) { return !isAddon(it) && hosts.indexOf(it.product_type) !== -1; });
    });
  }
  function blocked() { return short.length > 0 || orphan; }

  function message(list) {
    var parts = list.map(function (p) { var n = p.min - p.have; return n + ' more ' + p.title; });
    return 'Pavers ship by freight, so we need at least ' + list[0].min + ' pieces of each. Add ' +
      (parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0]) + ' to check out.';
  }

  // our own note and button changes must not wake the observers (they would check again, forever)
  function paint() {
    watched.forEach(function (w) { w.obs.disconnect(); });
    try { draw(); } finally { watched.forEach(function (w) { w.obs.observe(w.node, { childList: true, subtree: true }); }); }
  }
  function draw() {
    var on = blocked(), text = !on ? '' : orphan
      ? 'Add-ons are applied at our plant to the pieces you order with them: sealer to pavers or coping, bush-hammering to pavers (coping is bush-hammered as standard). Add those pieces, or remove the add-on, to check out.'
      : message(short);
    Array.prototype.forEach.call(document.querySelectorAll(CHECKOUT), function (b) {
      if (on) { if (!b.disabled) { b.disabled = true; b.dataset.mcMoqOff = '1'; } }
      else if (b.dataset.mcMoqOff) { b.disabled = false; delete b.dataset.mcMoqOff; }
      var note = b.parentNode && b.parentNode.querySelector('.mc-moq-note');
      if (on && !note) {
        note = document.createElement('p'); note.className = 'mc-moq-note'; note.setAttribute('role', 'alert');
        note.style.cssText = 'margin:0 0 10px;padding:8px 10px;border-left:2px solid #8f9551;background:rgba(143,149,81,.12);font-size:13px;line-height:1.45;text-align:left';
        b.parentNode.insertBefore(note, b);
      }
      if (note) { if (on) note.textContent = text; else note.remove(); }
    });
    Array.prototype.forEach.call(document.querySelectorAll(EXPRESS), function (el) { el.style.display = on ? 'none' : ''; });
  }

  function check() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (cart) { tries = 0; short = shortOf(cart); orphan = orphanOf(cart); paint(); })
      // a busy store (429) or a dropped request: try again shortly, three times, so the note isn't silently skipped
      .catch(function () { if (++tries <= 3) setTimeout(check, 1500 * tries); else tries = 0; })
      .then(function () { busy = false; });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(check, 150); }

  // a checkout the theme re-enabled on its own re-render is stopped here too
  document.addEventListener('click', function (e) {
    if (!blocked() || !e.target.closest) return;
    var b = e.target.closest(CHECKOUT); if (b) { e.preventDefault(); e.stopPropagation(); paint(); }
  }, true);
  document.addEventListener('submit', function (e) {
    if (!blocked()) return;
    var s = e.submitter; if (s && s.name === 'checkout') { e.preventDefault(); paint(); }
  }, true);

  function init() {
    ['#CartDrawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
      var node = document.querySelector(sel);
      if (!node) return;
      var obs = new MutationObserver(function () { if (blocked()) paint(); soon(); });
      watched.push({ obs: obs, node: node }); obs.observe(node, { childList: true, subtree: true });
    });
    ['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, soon); });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
